import React from "react";
import { Box } from "@mui/material";
import CustomCard from "../CustomCardComponent/CustomCard";
import { InvoiceSummary, InvoiceSummaryV2 } from "./OrderSummaryCard"
import { TypographyH2 } from "../../assets/fonts/typographyTheme";
import { PayLater } from "../Payments/paymentOptions";
import { PaymentMethodInfoCard } from "../Payments/PaymentMethodInfoCard";
import { useFeatureFlag } from "@/context/FeatureFlagContext";

export const OrderDetailSummaryCard = ({summaryData}) => {
    const isDiscountEnabled = useFeatureFlag("ONLINE_DISCOUNT");
    const invoiceSummary = isDiscountEnabled ?
                         <InvoiceSummaryV2 summaryData={summaryData} isOrderDetailsPage={true}/> 
                         : <InvoiceSummary summaryData={summaryData} isOrderDetailsPage={true}/>;
    return (
        <Box>
            <CustomCard
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "32px",
                    gap: "24px",
                }}
            >
                <TypographyH2 mb="24px" textTransform="capitalize">Summary</TypographyH2>
                {invoiceSummary}
                <TypographyH2>Payment Method</TypographyH2>
                {summaryData.paymentInfo ? <PaymentMethodInfoCard paymentMethod={summaryData.paymentInfo} isOrderDetailsPage={true}/> : <PayLater />}
            </CustomCard>
        </Box>
    );
};